import { NOTIFICATION_ACTION_TYPES } from '../actions/types';

const initialState = {
  // Email Settings
  emailSettings: [],
  emailSetting: null,
  emailSettingLoading: false,
  emailSettingError: null,

  // Twilio SMS Settings
  twilioSmsSettings: [],
  twilioSmsSetting: null,
  twilioSmsSettingLoading: false,
  twilioSmsSettingError: null,

  // MSG Club SMS Settings
  msgClubSmsSettings: [],
  msgClubSmsSetting: null,
  msgClubSmsSettingLoading: false,
  msgClubSmsSettingError: null,

  // Notification Settings (Email & SMS Templates)
  notificationSettings: [],
  notificationSetting: null,
  notificationSettingLoading: false,
  notificationSettingError: null,
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    // ==================== EMAIL SETTINGS ====================
    case NOTIFICATION_ACTION_TYPES.CREATE_EMAIL_SETTING_REQUEST:
    case NOTIFICATION_ACTION_TYPES.GET_EMAIL_SETTINGS_REQUEST:
    case NOTIFICATION_ACTION_TYPES.UPDATE_EMAIL_SETTING_REQUEST:
    case NOTIFICATION_ACTION_TYPES.DELETE_EMAIL_SETTING_REQUEST:
      return {
        ...state,
        emailSettingLoading: true,
        emailSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.CREATE_EMAIL_SETTING_SUCCESS:
      return {
        ...state,
        emailSettingLoading: false,
        emailSetting: action.payload,
        emailSettings: [...state.emailSettings, action.payload],
        emailSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.GET_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        emailSettingLoading: false,
        emailSettings: action.payload,
        emailSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.UPDATE_EMAIL_SETTING_SUCCESS:
      return {
        ...state,
        emailSettingLoading: false,
        emailSetting: action.payload,
        emailSettings: state.emailSettings.map(setting => 
          setting.id === action.payload.id ? action.payload : setting
        ),
        emailSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.DELETE_EMAIL_SETTING_SUCCESS:
      return {
        ...state,
        emailSettingLoading: false,
        emailSettings: state.emailSettings.filter(setting => setting.id !== action.payload),
        emailSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.CREATE_EMAIL_SETTING_FAIL:
    case NOTIFICATION_ACTION_TYPES.GET_EMAIL_SETTINGS_FAIL:
    case NOTIFICATION_ACTION_TYPES.UPDATE_EMAIL_SETTING_FAIL:
    case NOTIFICATION_ACTION_TYPES.DELETE_EMAIL_SETTING_FAIL:
      return {
        ...state,
        emailSettingLoading: false,
        emailSettingError: action.payload,
      };

    // ==================== TWILIO SMS SETTINGS ====================
    case NOTIFICATION_ACTION_TYPES.CREATE_TWILIO_SMS_SETTING_REQUEST:
    case NOTIFICATION_ACTION_TYPES.GET_TWILIO_SMS_SETTINGS_REQUEST:
    case NOTIFICATION_ACTION_TYPES.UPDATE_TWILIO_SMS_SETTING_REQUEST:
    case NOTIFICATION_ACTION_TYPES.DELETE_TWILIO_SMS_SETTING_REQUEST:
      return {
        ...state,
        twilioSmsSettingLoading: true,
        twilioSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.CREATE_TWILIO_SMS_SETTING_SUCCESS:
      return {
        ...state,
        twilioSmsSettingLoading: false,
        twilioSmsSetting: action.payload,
        twilioSmsSettings: [...state.twilioSmsSettings, action.payload],
        twilioSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.GET_TWILIO_SMS_SETTINGS_SUCCESS:
      return {
        ...state,
        twilioSmsSettingLoading: false,
        twilioSmsSettings: action.payload,
        twilioSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.UPDATE_TWILIO_SMS_SETTING_SUCCESS:
      return {
        ...state,
        twilioSmsSettingLoading: false,
        twilioSmsSetting: action.payload,
        twilioSmsSettings: state.twilioSmsSettings.map(setting => 
          setting.id === action.payload.id ? action.payload : setting
        ),
        twilioSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.DELETE_TWILIO_SMS_SETTING_SUCCESS:
      return {
        ...state,
        twilioSmsSettingLoading: false,
        twilioSmsSettings: state.twilioSmsSettings.filter(setting => setting.id !== action.payload),
        twilioSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.CREATE_TWILIO_SMS_SETTING_FAIL:
    case NOTIFICATION_ACTION_TYPES.GET_TWILIO_SMS_SETTINGS_FAIL:
    case NOTIFICATION_ACTION_TYPES.UPDATE_TWILIO_SMS_SETTING_FAIL:
    case NOTIFICATION_ACTION_TYPES.DELETE_TWILIO_SMS_SETTING_FAIL:
      return {
        ...state,
        twilioSmsSettingLoading: false,
        twilioSmsSettingError: action.payload,
      };

    // ==================== MSG CLUB SMS SETTINGS ====================
    case NOTIFICATION_ACTION_TYPES.CREATE_MSGCLUB_SMS_SETTING_REQUEST:
    case NOTIFICATION_ACTION_TYPES.GET_MSGCLUB_SMS_SETTINGS_REQUEST:
    case NOTIFICATION_ACTION_TYPES.UPDATE_MSGCLUB_SMS_SETTING_REQUEST:
    case NOTIFICATION_ACTION_TYPES.DELETE_MSGCLUB_SMS_SETTING_REQUEST:
      return {
        ...state,
        msgClubSmsSettingLoading: true,
        msgClubSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.CREATE_MSGCLUB_SMS_SETTING_SUCCESS:
      return {
        ...state,
        msgClubSmsSettingLoading: false,
        msgClubSmsSetting: action.payload,
        msgClubSmsSettings: [...state.msgClubSmsSettings, action.payload],
        msgClubSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.GET_MSGCLUB_SMS_SETTINGS_SUCCESS:
      return {
        ...state,
        msgClubSmsSettingLoading: false,
        msgClubSmsSettings: action.payload,
        msgClubSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.UPDATE_MSGCLUB_SMS_SETTING_SUCCESS:
      return {
        ...state,
        msgClubSmsSettingLoading: false,
        msgClubSmsSetting: action.payload,
        msgClubSmsSettings: state.msgClubSmsSettings.map(setting => 
          setting.id === action.payload.id ? action.payload : setting
        ),
        msgClubSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.DELETE_MSGCLUB_SMS_SETTING_SUCCESS:
      return {
        ...state,
        msgClubSmsSettingLoading: false,
        msgClubSmsSettings: state.msgClubSmsSettings.filter(setting => setting.id !== action.payload),
        msgClubSmsSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.CREATE_MSGCLUB_SMS_SETTING_FAIL:
    case NOTIFICATION_ACTION_TYPES.GET_MSGCLUB_SMS_SETTINGS_FAIL:
    case NOTIFICATION_ACTION_TYPES.UPDATE_MSGCLUB_SMS_SETTING_FAIL:
    case NOTIFICATION_ACTION_TYPES.DELETE_MSGCLUB_SMS_SETTING_FAIL:
      return {
        ...state,
        msgClubSmsSettingLoading: false,
        msgClubSmsSettingError: action.payload,
      };

    // ==================== NOTIFICATION SETTINGS ====================
    case NOTIFICATION_ACTION_TYPES.CREATE_NOTIFICATION_SETTING_REQUEST:
    case NOTIFICATION_ACTION_TYPES.GET_NOTIFICATION_SETTINGS_REQUEST:
    case NOTIFICATION_ACTION_TYPES.UPDATE_NOTIFICATION_SETTING_REQUEST:
    case NOTIFICATION_ACTION_TYPES.DELETE_NOTIFICATION_SETTING_REQUEST:
      return {
        ...state,
        notificationSettingLoading: true,
        notificationSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.CREATE_NOTIFICATION_SETTING_SUCCESS:
      return {
        ...state,
        notificationSettingLoading: false,
        notificationSetting: action.payload,
        notificationSettings: [...state.notificationSettings, action.payload],
        notificationSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.GET_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        notificationSettingLoading: false,
        notificationSettings: action.payload,
        notificationSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.UPDATE_NOTIFICATION_SETTING_SUCCESS:
      return {
        ...state,
        notificationSettingLoading: false,
        notificationSetting: action.payload,
        notificationSettings: state.notificationSettings.map(setting => 
          setting.id === action.payload.id ? action.payload : setting
        ),
        notificationSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.DELETE_NOTIFICATION_SETTING_SUCCESS:
      return {
        ...state,
        notificationSettingLoading: false,
        notificationSettings: state.notificationSettings.filter(setting => setting.id !== action.payload),
        notificationSettingError: null,
      };
    
    case NOTIFICATION_ACTION_TYPES.CREATE_NOTIFICATION_SETTING_FAIL:
    case NOTIFICATION_ACTION_TYPES.GET_NOTIFICATION_SETTINGS_FAIL:
    case NOTIFICATION_ACTION_TYPES.UPDATE_NOTIFICATION_SETTING_FAIL:
    case NOTIFICATION_ACTION_TYPES.DELETE_NOTIFICATION_SETTING_FAIL:
      return {
        ...state,
        notificationSettingLoading: false,
        notificationSettingError: action.payload,
      };

    // Reset State
    case NOTIFICATION_ACTION_TYPES.RESET_NOTIFICATION_STATE:
      return initialState;

    default:
      return state;
  }
};